import qs from 'qs'

function parseSearch(str) {
  return qs.parse(str, { ignoreQueryPrefix: true })
}

export function getSearchValue(key) {
  const search = parseSearch(window.location.search)
  return search[key]
}

function smoothlyScrollTo(scroller, target) {
  const fRequestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame

  const prevTop = scroller.scrollTop
  const nextTop = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop

  const startTime = new Date().getTime()
  const duration = 250

  const animation = () => {
    const ellapseTime = new Date().getTime() - startTime
    if (ellapseTime >= duration) {
      scroller.scrollTop = nextTop
    } else {
      scroller.scrollTop = prevTop + ((nextTop - prevTop) * ellapseTime) / duration
      fRequestAnimationFrame(animation)
    }
  }

  fRequestAnimationFrame(animation)
}

function newPath(query) {
  const newSearch = Object.assign({}, qs.parse(window.location.search, { ignoreQueryPrefix: true }), query)
  const prevUrl = window.location.pathname

  return prevUrl + '?' + qs.stringify(newSearch)
}

function validateEmail(email) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
}

function validatePhone(phone) {
  return /^[0-9]+$/.test(phone)
}

function safeParse(str) {
  let obj = null
  try {
    obj = JSON.parse(str)
  } catch (e) { }

  return obj
}

function hashTarget() {
  const hash = window.location.hash ? window.location.hash.replace('#', '') : null

  if (hash) {
    const node = document.getElementById(hash)
    if (node && node.offsetTop) {
      setTimeout(function () {
        $(window).scrollTop(node.offsetTop - 120)
      }, 500)
    }
  }
}

/**
 *
 * @param {string} src 图片地址
 * @param {object} opt 图片处理配置
 * @param {number} opt.width 图片宽度
 * @param {number} opt.height  图片高度
 * @param {boolean|number} opt.quality 是否压缩，默认:false，true的话默认90压缩率
 * @param {'jpg'|'png'} opt.format 图片格式转换
 * @param {boolean} opt.cut 是否剪裁图片
 */
function ossImgCompress(src, opt) {
  const { width, height, quality, format, cut } = Object.assign(
    {
      quality: false,
      cut: false,
    },
    opt
  )
  let imgSrc = ''
  if (src && src != '' && opt) {
    imgSrc = src
    if (src.indexOf('insta360.com') !== -1 || src.indexOf('.aliyuncs.com/static/') !== -1) {
      let url = new URL(src)
      let search = new URLSearchParams(url.search)
      let config = ['image', 'auto-orient,1']
      if (width && height) {
        config.push(`resize,${cut ? 'm_fill,limit_0' : 'm_lfit'},w_${width},h_${height}`)
      } else if (width || height) {
        if (width) {
          config.push(`resize,m_lfit,w_${width}`)
        }
        if (height) {
          config.push(`resize,m_lfit,h_${height}`)
        }
      }
      if (format) {
        config.push(`format,${format}`)
        if (format === 'jpg') {
          config.push(`interlace,1`)
        }
      }
      if (quality) {
        config.push(`quality,q_${typeof quality === 'number' ? quality : '90'}`)
      }
      search.set('x-oss-process', config.join('/'))
      imgSrc = url.origin + url.pathname + '?' + search.toString()
    }
  }
  return imgSrc
}

// 判断是否支持webp
export function check_webp_feature(callback) {
  let kTestImages = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA'
  let img = new Image()
  img.onload = function () {
    callback(img.width > 0 && img.height > 0)
  }
  img.onerror = function () {
    callback(false)
  }
  img.src = 'data:image/webp;base64,' + kTestImages
}

export function commonTracking(name, data) {
  console.log('commonTracking', name, data)
  window.ta?.track?.(name, data)
  window.collectEvent?.(name, data)
}

export function commonTrackingWithBeacon(name, data) {
  window.ta?.trackWithBeacon?.(name, data)
  window.collectEvent?.(name, data)
}

export default {
  parseSearch,
  getSearchValue,
  smoothlyScrollTo,
  newPath,
  validateEmail,
  safeParse,
  validatePhone,
  hashTarget,
  ossImgCompress,
}
